import { handlers as authMock } from './auth';
import { handlers as regionalStructureMock } from './regionalStructure';
import { handlers as storeAuthorityMock } from './storeAuthority';
import { handlers as storeAvailableMock } from './storeAvailableAdjust';
import { handlers as urgentAnnouncementMock } from './urgentAnnouncement';

export const handlers = [
  ...authMock,
  ...storeAvailableMock,
  ...storeAuthorityMock,
  ...regionalStructureMock,
  ...urgentAnnouncementMock
];
